// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 195 ? "bf5f3635" : chunkId) + "." + {"195":"bddb1460769bf98e","257":"78d812f7aac2626c"}[chunkId] + ".js";
};